// returns true if firstArray intersect secondArray = {}
export function hasEmptyIntersection(firstArray, secondArray) {
  for (const element of firstArray) {
    if (secondArray.includes(element)) {
      return false;
    }
  }
  return true;
}

// returns true if firstArray intersect secondArray = {element}
export function intersectionIsExactlyElement(firstArray, secondArray, element) {
  let elementInIntersection = false;
  for (const firstArrayElement of firstArray) {
    if (secondArray.includes(firstArrayElement)) {
      if (firstArrayElement === element) {
        elementInIntersection = true;
      } else {
        return false;
      }
    }
  }
  return elementInIntersection;
}

// NOTE Ember.EnumerableUtils is removed in 2.0 copied (with a few small changes) from
// https://github.com/emberjs/ember.js/blob/v1.13.13/packages/ember-metal/lib/enumerable_utils.js

/**
  Calculates the intersection of two arrays. This method returns a new array
  filled with the records that the two passed arrays share with each other.
  If there is no intersection, an empty array will be returned.
  ```javascript
  var array1 = [1, 2, 3, 4, 5];
  var array2 = [1, 3, 5, 6, 7];
  Ember.EnumerableUtils.intersection(array1, array2); // [1, 3, 5]
  var array1 = [1, 2, 3];
  var array2 = [4, 5, 6];
  Ember.EnumerableUtils.intersection(array1, array2); // []
  ```
  @method intersection
  @param {Array} array1 The first array
  @param {Array} array2 The second array
  @returns {Array} The intersection of the two passed arrays.
  @public
*/
export function intersection(array1, array2) {
  const array1HasElement = array1.reduce((array1HasElement, element) => {
    array1HasElement.add(element);
    return array1HasElement;
  }, new Set());
  const result = new Array();
  for (const element of array2) {
    if (array1HasElement.has(element)) {
      result.push(element);
    }
  }
  return result;
}